import styled from "styled-components";
import {JackpotAmountDefaultBox} from "./jackpot-amount.default.box";

export const JackpotAmountMrgreenBox = styled(JackpotAmountDefaultBox)`
    width: 100%;
`